import httpClient from './httpClient'

export default {
  async getLibrary() {
    let ret = await httpClient.get('library')
    return ret
  },
  async removeReferBlock(library, data) {
    let ret = await httpClient.post(
      `library/${library}?action=referValidation`,
      data
    )
    return ret
  },
  async getRefers(library) {
    let ret = await httpClient.get(`library/${library}?action=refer`)
    return ret
  },
  async addRefer(library, data) {
    let ret = await httpClient.post(`library/${library}?action=refer`, data)
    return ret
  },
  async addMultipleRefers(library, data) {
    let ret = await httpClient.post(`library/${library}?action=refer`, data)
    return ret
  },
  async removeRefer(library, id) {
    let ret = await httpClient.delete(`library/${library}?action=refer`, {
      data: {
        refer_id: id,
      },
    })
    return ret
  },
}
